/**
 * What an AI assistant can and cannot do through the MCP server, as a
 * sequence. The message to get first: reading and drafting flow through;
 * anything that changes your record, or sends anything, stops at you. Three
 * steps, one emphasis (the approval), and the real tool call underneath as
 * the artifact rather than a picture of one.
 */
const STEPS = [
  { k: "ask", title: "Your assistant asks", body: "Claude, or any MCP client" },
  { k: "answer", title: "NextOpp answers", body: "scores, tailors, reads your pipeline" },
  { k: "approve", title: "You approve", body: "every write, in the app — nothing is submitted for you", emphasis: true },
];

export default function McpFlow() {
  return (
    <figure data-testid="mcp-flow">
      <ol className="grid grid-cols-3 gap-x-3">
        {STEPS.map((s, i) => (
          <li key={s.k} className="relative min-w-0" data-testid={`mcp-step-${s.k}`}>
            {i < STEPS.length - 1 && (
              <span aria-hidden="true" className="absolute top-[11px] left-[26px] right-[-6px] h-px bg-white/15" />
            )}
            <span
              aria-hidden="true"
              className={`relative z-10 inline-grid place-items-center w-[22px] h-[22px] rounded-full font-mono text-[10px] font-bold ${
                s.emphasis ? "bg-brand text-white ring-4 ring-brand/25" : "bg-white/10 text-white/80 border border-white/20"
              }`}
            >
              {i + 1}
            </span>
            <div className={`mt-2.5 text-[13px] font-medium ${s.emphasis ? "text-white" : "text-white/85"}`}>{s.title}</div>
            <div className="mt-0.5 text-[11px] leading-snug text-white/55">{s.body}</div>
          </li>
        ))}
      </ol>
      {/* The artifact: the shape of an actual tool call, and its answer. */}
      <div className="mt-5 pt-4 border-t border-white/10 font-mono text-[11px] leading-relaxed" data-testid="mcp-call">
        <div className="text-white/85">
          <span className="text-dawn-300">nextopp.analyze_job</span>
          <span className="text-white/55">(job_id=</span>"j-1"<span className="text-white/55">)</span>
          <span className="text-white/60"> → match_score: </span><span className="text-white">87</span>
          <span className="text-white/60">, missing: </span><span className="text-white">["Terraform"]</span>
        </div>
        <div className="mt-1.5 text-emerald-300">✓ read-only · submitting still needs you</div>
      </div>
      <figcaption className="sr-only">
        Your assistant asks; NextOpp answers with scores, tailoring and your pipeline; you approve every write in the app, and nothing is submitted for you.
      </figcaption>
    </figure>
  );
}
